import { render } from "./IngresosEmbargoGobernacionComponent.vue?vue&type=template&id=8a8d9a96"
import script from "./IngresosEmbargoGobernacionComponent.vue?vue&type=script&lang=js"
export * from "./IngresosEmbargoGobernacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__